import React, { useRef, useEffect, useState } from "react";

const LoginWithOTP = ({ length = 6, email, setOtpValue }) => {
  const inputRefs = useRef([]);
  const [otp, setOtp] = useState(Array(length).fill(""));

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (e, index) => {
    const value = e.target.value;

    // Only allow single digit
    if (!/^[0-9]?$/.test(value)) {
      e.target.value = "";
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    const otpString = newOtp.join("");

    // ✅ Only update when all digits are filled
    if (newOtp.length === length) {
      setOtpValue(otpString)
    }

    // Always keep caret at right
    setTimeout(() => {
      e.target.setSelectionRange(1, 1);
    }, 0);

    // Auto-focus next
    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    setTimeout(() => {
      e.target.setSelectionRange(e.target.value.length, e.target.value.length);
    }, 0);
  };

  return (
    <>
      <div className="form-group validate-input">
        <label className="label-form-control mb-0 label-form-control-lg mb-6">{'Sign-In Code'}<span className="text-danger-common"> * </span></label>
        <div className="d-flex gap-24 my-8">
          {Array.from({ length }).map((_, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={otp[index]}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-50p h-50p text-center border border-radius-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default LoginWithOTP;
